module.exports = __webpack_public_path__ + "tables/media/tables-dark.ddffa99f.svg";